import type { ImageMetadataTypes, QACheckResult } from '../../qa-checks/type/qa-engine';
import type { SpanT } from '../labelling-v2/studio-store/types';
import type { ImageOnChangeMetadata } from '../types';
type QAResult = {
  [ruleName: string]: QACheckResult<ImageMetadataTypes>;
};
export function computeImageOnChangeMetadata(qaResult: QAResult, annotationSpans: Map<string, SpanT[]>): ImageOnChangeMetadata | undefined {
  const failingRules = new Map<string, {
    description: string;
    start: number;
    end: number;
  }>();
  for (const [ruleName, ruleResult] of Object.entries(qaResult)) {
    if (ruleResult.summarizedResult) {
      continue;
    }
    let start = 0;
    let end = 0;
    for (const instance of ruleResult.instanceResult) {
      if (instance.result) {
        continue;
      }
      for (const metadata of instance.metadata) {
        if (metadata.type === 'ANNOTATION') {
          const spans = annotationSpans.get(metadata.id) ?? [];
          const firstSpan = spans[0];
          const lastSpan = spans[spans.length - 1];
          if (firstSpan && lastSpan) {
            start = firstSpan.start;
            end = lastSpan.end;
          }
        }
      }
    }
    failingRules.set(ruleName, {
      description: ruleResult.description,
      start,
      end
    });
  }
  return {
    type: ('image' as const),
    failingChecks: [...failingRules].map(([ruleName, {
      description,
      start,
      end
    }]) => ({
      ruleName,
      description,
      frame: {
        start,
        end
      }
    }))
  };
}